import { createFileRoute } from '@tanstack/react-router';
import { McpOAuthClientsPage } from '@/features/admin/pages/mcp';

export const Route = createFileRoute('/admin/mcp/oauth')({
  component: McpOAuthClientsPage,
});
